import { render, staticRenderFns } from "./displaySchedule.vue?vue&type=template&id=630a4853&scoped=true&"
import script from "./displaySchedule.vue?vue&type=script&lang=js&"
export * from "./displaySchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a4853",
  null
  
)

export default component.exports